<template>
    <div>
        <div class="page-title">结算账户</div>
        
        <pay-box title="结算账户">
            <div v-if="ready">
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">账户类型</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-radio-group @change="typeChange" v-model="params.account_info.bank_account_type">
                            <a-radio-button value="74" v-if="!applyManager.isPerson()">对公账户</a-radio-button>
                            <a-radio-button value="75" v-if="!applyManager.isCompany()">对私账户</a-radio-button>
                        </a-radio-group>
                    
                    </div>
                
                </div>
                <div class="pay-apply-tips">你为经营者对公银行账户，请务必填写开户名为的银行账号</div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">开户名称</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-input v-model="params.account_info.account_name" class="pay-apply-input"/>
                    
                    </div>
                
                </div>
                <div class="pay-apply-tips">
                    1、选择经营者个人银行卡时，开户名称必须与身份证姓名一致。 <br>
                    2、选择对公账户时，开户名称必须与营业执照上的“商户名称”一致
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">开户行</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-select
                            class="at-select pay-apply-input"
                            show-search
                            v-model="params.account_info.bank_data.bank_alias_code"
                            placeholder="请选择银行"
                            :default-active-first-option="false"
                            :show-arrow="false"
                            :filter-option="false"
                            :not-found-content="null"
                            @search="bankSearch"
                            @change="bankChanged"
                        >
                            <a-select-option v-for="d in banks" :key="d.value" :value="d.bank_alias_code">
                                {{ d.bank_alias }}
                            </a-select-option>
                        </a-select>
                    
                    </div>
                
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">银行账号</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <at-input v-model="params.account_info.account_number" class="pay-apply-input"/>
                    
                    </div>
                
                </div>
                
                <template v-if="showBankExtra">
                    
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">开户银行联行号</div>
                        
                        <div class="pay-apply-item-content">
                            
                            <at-input v-model="params.account_info.bank_branch_id" class="pay-apply-input"/>
                        
                        </div>
                    
                    </div>
                    <div class="pay-apply-tips">
                        开户银行联行号与开户银行全称二选一填写
                    </div>
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">开户银行全称 （含支行）</div>
                        
                        <div class="pay-apply-item-content">
                            
                            <at-input v-model="params.account_info.bank_name" class="pay-apply-input"/>
                        
                        </div>
                    
                    </div>
                    
                    <div class="pay-apply-tips">
                        开户银行联行号与开户银行全称二选一填写
                    </div>
                </template>
            
            </div>
            <div v-else>
                <p>请先完成主体资料填写</p>
                <a @click="changeStep(3)">立即前往</a>
            </div>
        
        </pay-box>
        
        
        <div class="pay-apply-btns">
            <button @click="saveChange(2)" class="btn btn-white">返回</button>
            <button @click="saveChange(6)" class="btn">下一步</button>
        </div>
    
    </div>
</template>

<script>
import AtInput from "../../../../components/AtInput";
import PayBox from "./PayBox";
import api from "../../../../repo/api";
import ecApply from "@/store/ec-apply";

export default {
    name: "Step5",
    components: {PayBox, AtInput},
    props: {
        apply: Object
    },
    mounted() {
        this.init()
    },
    data() {
        return {
            bankLoading: false,
            applyManager: ecApply,
            bankOptions: [],
            ready: false,
            bankExtraType: "address",
            params: {
                account_info: {
                    bank_account_type: ecApply.isPerson() ? '75' : '74',
                    account_bank: '',
                    account_name: '',
                    account_number: '',
                    bank_data: {},
                }
            },
            banks: [],
        }
    },
    computed: {
        showBankExtra() {
            return this.params.account_info.bank_data &&
                this.params.account_info.bank_data.need_bank_branch;
        }
    },
    methods: {
        init() {
            
            this.params.account_info = this.applyManager.getApplyValue('account_info', this.params.account_info)
            
            if (this.params.account_info.bank_data) {
                this.banks = [this.params.account_info.bank_data]
            } else {
                this.typeChangeVal(this.params.account_info.bank_account_type)
            }
            
            this.ready = true
        },
        typeChange(e) {
            this.typeChangeVal(e.target.value)
        },
        typeChangeVal() {
            this.bankSearch('')
        },
        saveChange(step) {
            
            if (!this.ready) return this.changeStep(step)
            
            this.$loading.show()
            
            let params = {...this.params}
            
            if (!this.params.account_info.bank_data.need_bank_branch) {
                delete params.account_info.bank_name
                delete params.account_info.bank_branch_id
            }
            
            api.post('/ec-pay-apply/save-bank-account-info', this.params, (data) => {
                
                this.$loading.hide()
                
                if (data.code !== 0) this.$message.data(data)
                
                if (data.code === 0) {
                    this.applyManager.gotoStep(step, data.data)
                }
                
            })
        },
        changeStep(step) {
            this.$emit('change', step)
        },
        bankSearch(keyword) {
            
            this.bankLoading = true;
            
            const type = this.params.account_info.bank_account_type === '74' ? 'company' : 'personal'
            
            this.applyManager.bankSearch(keyword, type).then(res => {
                this.bankLoading = false;
                this.banks = res.data
            })
        },
        bankChanged(e) {
            const bank = this.banks.find(d => d.bank_alias_code === e)
            
            if (bank) {
                this.params.account_info.account_bank = bank.account_bank
                this.params.account_info.bank_data = bank
            }
        },
    }
}
</script>

<style scoped>
.pay-apply-item-title {
    width: 80px;
}

.pay-apply-tips {
    padding-left: 100px;
}
</style>